import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconUnpin2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"unpin-2"} maskId="square-filled-radius-0-stroke-1-IconUnpin2"><path d="M20.3633 19.6562L19.6367 20.3438L15.5342 16H12.5V20.5L12 22L11.5 20.5V16H4V15.5C4 12.5381 5.61003 9.95381 8 8.57129V8.02246L2.63672 2.34375L3.36328 1.65625L20.3633 19.6562Z" fill="currentColor"/><path d="M16 8.57129C18.39 9.95381 20 12.5381 20 15.5V16H18.2607L8 5.13477V2H16V8.57129Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconUnpin2;
